var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.pipelines),function(pipeline){return _c('PipelineCard',{key:pipeline.id,staticClass:"my-3",attrs:{"pipeline":pipeline},on:{"click":_vm.onClick}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }